import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Pessoas',
    financial_metrics: 'Métricas financeiras',
    onboarding_and_quality: 'Onboarding & Qualidade',
    subscriptions: 'Subscrições atuais',
    payments: 'Pagamentos',
    last_invoices: 'Últimas faturas',
  },
  fields: {
    google_profile: 'Perfil Google',
    owner_name: 'Nome do proprietário',
    owner_phone_number: 'Telefone do proprietário',
    company_phone_number: 'Telefone do restaurante',
    address: 'Morada',
    onboarding_manager: 'Gestor de onboarding',
    sales_manager: 'Gestor de vendas',
    last_30_days_sales: 'Receita dos últimos 30 dias',
    lifetime_sales: 'Receita total acumulada',
    monthly_sales_other_platforms: 'Vendas em Apps de Entrega',
    last_payout: 'Último pagamento',
    potential_tier: 'Pontuação Potencial',
    current_tier: 'Pontuação IST',
    signed_at: 'Data de Fecho',
    live_from: 'Data de Lançamento',
    onboarding_quality_score: 'Pontuação de Qualidade de Lançamento',
    is_google_business_available: 'Google Business disponível',
    is_smart_pricing_configured: 'Preços mais baixos que Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Flyer promocional enviado',
    is_menu_fully_configured: 'Todos os itens do menu disponíveis',
    has_offers_on_competitor_platforms:
      'O restaurante tem ofertas ativas no Wolt, Uber, Lieferando (exceto oferta de entrega gratuita)?',
    is_instagram_story_shared: 'Instagram story partilhado com o proprietário',
    is_order_system_connected_to_website:
      'Website Foodamigos conectado OU botão de encomenda online adicionado ao website do restaurante',
    delivery_mode: 'Estafetas',
    has_storefront: 'Website {{provider}}',
    screening_date: 'Data de triagem',
  },
  setup_fee: {
    title: 'Taxa de implementação',
    status: {
      [InvoiceStatus.Paid]: 'Pago',
      [InvoiceStatus.Pending]: 'Pendente',
      [InvoiceStatus.Processing]: 'Em processamento',
      [InvoiceStatus.Refunded]: 'Reembolsado',
      [InvoiceStatus.PartiallyRefunded]: 'Parcialmente reembolsado',
      [InvoiceStatus.Failed]: 'Falhado',
    },
  },
  labels: {
    yes: 'Sim',
    no: 'Não',
    month: 'Mês',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Ativo',
    [CompanyOperationalStatus.Paused]: 'Pausado',
    [CompanyOperationalStatus.Suspended]: 'Cancelado',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Standard',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Mensal',
    [SubscriptionTerm.Annual]: 'Anual',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Motoristas próprios',
    [DeliveryMode.External]: 'Motoristas {{provider}}',
  },
  buttons: {
    view_details: 'Ver detalhes',
    open: 'Abrir',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
  },
};
